import React from 'react'

const ContactInfoSkeleton = () => (
  <div className={'flex w-full flex-col gap-5 lg:flex-row'}>
    <div className={'flex w-full items-center gap-3 lg:w-1/2'}>
      <div
        className={
          'bg-skeleton-primary h-[80px] w-[80px] min-w-[80px] animate-pulse rounded-full text-transparent'
        }
      >
        .
      </div>
      <div className={'flex w-full flex-col gap-1'}>
        <div
          className={
            'bg-skeleton-primary h-[18px] animate-pulse animate-pulse rounded-md py-0 text-transparent'
          }
        >
          6
        </div>
        <div
          className={
            'bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent'
          }
        >
          .
        </div>
        <div
          className={
            'bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent'
          }
        >
          .
        </div>
        <div
          className={
            'bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent'
          }
        >
          .
        </div>
        <div
          className={
            'bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent'
          }
        >
          .
        </div>
      </div>
    </div>
    <div className={'ml-[92px] flex w-[calc(100%-92px)] flex-col gap-1 lg:ml-0 lg:w-1/2'}>
      <div
        className={
          'bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent'
        }
      >
        .
      </div>
      <div
        className={
          'bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent'
        }
      >
        .
      </div>
      <div
        className={
          'bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent'
        }
      >
        .
      </div>
      <div
        className={
          'bg-skeleton-primary h-[15px] animate-pulse animate-pulse rounded-md py-0 text-transparent'
        }
      >
        .
      </div>
    </div>
  </div>
)

export default ContactInfoSkeleton
